import React, { useState } from 'react';
import {
    List, Datagrid, FunctionField, AutocompleteArrayInput, FormDataConsumer, SimpleList, SimpleForm, Create, Edit, EditButton, TextInput, Toolbar, SaveButton, useRedirect, useRefresh
} from 'react-admin';
import { useMediaQuery, withStyles, IconButton, Dialog, ListItem, ListItemIcon, ListItemText, Button } from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ScrollableTable from './components/ScrollableTable';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
import ImageGalleryDialog from './components/ImageGalleryDialog';
import RaImagesInput from './components/RaImagesInput';
import RaAutocompleteInput from './components/RaAutocompleteInput';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import queryString from 'query-string';
import { Link } from "react-router-dom";
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import { hideName, hideMobileNumber} from "./sharedData";
import CustomCreateButton from './components/CustomCreateButton';

export const ClientsInfo = (props) => {
    const location = useLocation();
    const refresh = useRefresh();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Mobile", "Name"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Mobile");
    let filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" } }

    return (
        <div>
            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomCreateButton label="Create Client" basePath={props.basePath} resource={props.resource} />
            </div>
            <List {...props}
                style={{marginTop: 20}}
                empty={false}
                title="Verify Vehicles"
                bulkActionButtons={false}
                exporter={false}
                filter={filter}
                actions={false}
                pagination={<CustomPagination />}
            >

                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => hideName(record.client_name)}
                        secondaryText={record => (<div>
                            {record.owner_name && <div><span style={{ color: "#5a5a5a" }}>Owner Name: </span>{hideName(record.owner_name)}</div>}
                            {record.owner_mobile && <div><span style={{ color: "#5a5a5a" }}>Owner Mobile: </span>{hideMobileNumber(record.owner_mobile)}</div>}
                            {record.client_mobile && <div><span style={{ color: "#5a5a5a" }}>Client Mobile: </span>{hideMobileNumber(record.client_mobile)}</div>}
                            {record.billing_name && <div><span style={{ color: "#5a5a5a" }}>Billing Name: </span>{hideName(record.billing_name)}</div>}
                            {record.gstin && <div><span style={{ color: "#5a5a5a" }}>GstIn: </span>{record.gstin}</div>}
                            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <span style={{ color: "#5a5a5a" }}>Client Parkings:</span>
                                <ParkingArrayField {...props} record={record} source="client_parkings" label="Client Parkings" />
                            </div>

                            {!viewOnly && <div style={{ display: "flex", gap: 10, justifyContent: 'space-between', alignItems: "center" }}>
                                <EditButton {...props} record={record} />  <Link to={`/getParkingTerminals?${queryString.stringify({ clientInfo: JSON.stringify({ client_info_id: record.id, owner_name: record.owner_name }) })}`} style={{ textDecoration: "none" }}>
                                    <Button title="Devices">
                                        <PhoneAndroidIcon style={{ color: "#334d6e", fontSize: 20 }} />
                                    </Button>
                                </Link> <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/clientsInfo'} />
                            </div>}
                        </div>)}

                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid className={!viewOnly ? 'clientInfoDataGrid': ''} component={ScrollableTable}>
                        <FunctionField source="owner_name" label="Owner Name" render={record => record && record.owner_name ? hideName(record.owner_name) : "-"} />
                        <FunctionField source="owner_mobile" label="Owner Mobile" render={record => record && record.owner_mobile ? hideMobileNumber(record.owner_mobile) : "-"} />
                        <FunctionField source="client_name" label="Client Name" render={record => record && record.client_name ? hideName(record.client_name) : "-"} />
                        <FunctionField source="client_mobile" label="Client Mobile" render={record => record && record.client_mobile ? hideMobileNumber(record.client_mobile) : "-"} />
                        <FunctionField source="billing_name" label="Billing Name" render={record => record && record.billing_name ? hideName(record.billing_name): "-"} />
                        <FunctionField source="gstin" label="GstIn" render={record => record && record.gstin ? record.gstin : "-"} />
                        <ParkingArrayField source="client_parkings" label="Client Parkings" />
                        <FunctionField source="identity_proofs" label="Identity Proofs" render={(record) => {
                            if (record && record.identity_proofs !== "[]" && record.identity_proofs !== "" && record.identity_proofs != null) {
                                let images = JSON.parse(record.identity_proofs)
                                return <ImageGalleryDialog thumbnail={true} record={record} getImages={(record) => [...images]} />
                            } else {
                                return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
                                    <BrokenImageOutlinedIcon />
                                </div>
                            }

                        }} />
                        {!viewOnly && <FunctionField className="ListIconsContainerClientInfo" render={record => record &&
                            <div className="ListIcons">
                                <div>
                                    <EditButton {...props} title="Edit" label={false} record={record} />
                                </div>
                                <div>
                                    <Link to={`/getParkingTerminals?${queryString.stringify({ clientInfo: JSON.stringify({ client_info_id: record.id, owner_name: record.owner_name }) })}`}
                                        style={{ textDecoration: "none" }}>
                                        <Button title="Devices">
                                            <PhoneAndroidIcon style={{ color: "#334d6e", fontSize: 19 }} />
                                        </Button>
                                    </Link>
                                </div>
                                <div>
                                    <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/clientsInfo'} />
                                </div>
                            </div>
                        } />}
                    </Datagrid>
                }
            </List>
        </div>
    )
};

function ParkingArrayField(props) {
    const { record, source } = props;

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    if (typeof record[source] !== "string")
        return null;

    const parkings = record[source].split("|");

    return (
        <div style={{ textAlign: "left", display: "block", alignItems: "center", flex: 1 }}>
            <IconButton style={{ width: 40, height: 40, fontSize: 16, color: customTheme.palette.secondary.main }} onClick={openDialog}>{parkings.length}</IconButton>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog} PaperProps={{ style: { maxWidth: 400 } }}>
                {parkings.map(parking => (
                    <Link to={`/getParkingTerminals?${queryString.stringify({ parking: JSON.stringify({ parking_info_id: parking.split(':')[1]?.trim(), general_name: parking.split(':')[0]?.trim() }) })}`} style={{ color: "#272727", textDecoration: 'none' }}>
                        <ListItem button>
                            <ListItemIcon style={{ marginRight: 10 }}><DirectionsCarIcon /></ListItemIcon>
                            <ListItemText primary={parking.split(':')[0].trim()} />
                        </ListItem>
                    </Link>
                ))}
            </Dialog>
        </div>
    );
}

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

export const CreateClientInfo = (props) => {
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Create {...props} onFailure={onFailure} onSuccess={onSuccess}>
            <SimpleForm {...props} redirect="list" validate={(values) => validateClientInfo(values)} toolbar={<CustomToolbar />}>

                <div className="formLabel-bold" style={{ marginTop: 5 }}>Client Details</div>
                <div className="grid-250" style={{ marginTop: 8 }}>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Owner Name</div>
                        <TextInput source="owner_name" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Owner Mobile</div>
                        <TextInput source="owner_mobile" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Client Name</div>
                        <TextInput source="client_name" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Client Mobile</div>
                        <TextInput source="client_mobile" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Client Email</div>
                        <TextInput source="client_email" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Billing Name</div>
                        <TextInput source="billing_name" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>GstIn</div>
                        <TextInput source="gstin" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                </div>
                <div className="formLabel-regular" style={{ marginTop: 8 }}>Parking Location</div>
                <div className="grid-250" style={{ marginTop: 8 }}>
                    <RaAutocompleteInput multiple={true} source="parking_info_id" resourceParam="name" resourcePath="parkings" label="" getOptionValue={option => option["parking_info_id"]} getOptionLabel={option => `${option["general_name"]} : ${option["parking_info_id"]}`} style={{ width: "100%" }} filter={{ withOutClientInfo: true }} />
                </div>
                <RaImagesInput source="identity_proofs" style={{ margin: "30px 0 30px" }} />
            </SimpleForm>
        </Create>
    )
};

const CustomToolbar = withStyles(toolbarStyles)(props => (
    <Toolbar {...props}>
        <SaveButton style={{ backgroundColor: "#18cc69", marginTop: 13, width: "120px", borderRadius: 5 }} disableElevation />
    </Toolbar>
));

const validateClientInfo = (values) => {

    const emailRegex = /\S+@\S+\.\S+/;
    const ownerMobileRegex = /^\d{10}$/g;
    const clientMobileRegex = /^\d{10}$/g;
    const errors = {};

    if ((values.owner_name == null || values.owner_name === "") && (values.client_name == null || values.client_name === "")) {
        errors.owner_name = 'Owner Name is Required';
        errors.client_name = 'Client Name is Required';
    }

    if ((values.owner_mobile == null || values.owner_mobile === "") && (values.client_mobile == null || values.client_mobile === "")) {
        errors.owner_mobile = 'Owner Name is Required';
        errors.client_mobile = 'Client Name is Required';
    }

    if (!clientMobileRegex.test(values.client_mobile) && !ownerMobileRegex.test(values.owner_mobile)) {
        errors.client_mobile = 'Invalid Mobile Number';
        errors.owner_mobile = 'Invalid Mobile Number';
    }

    if (values.client_email && values.client_email.length > 0) {
        if (!emailRegex.test(values.client_email)) {
            errors.client_email = 'Invalid Email';
        }
    }

    return errors;
};

export const EditClientInfo = (props) => {
    const optionRenderer = choice => `${choice.name}`;
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (<Edit {...props} onFailure={onFailure} onSuccess={onSuccess} undoable={false}>
        <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
            <div className="formLabel-bold" style={{ marginTop: 5 }}>Client Details</div>
            <div className="grid-250" style={{ marginTop: 8 }}>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Owner Name</div>
                    <TextInput source="owner_name" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Owner Mobile</div>
                    <TextInput source="owner_mobile" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Client Name</div>
                    <TextInput source="client_name" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Client Mobile</div>
                    <TextInput source="client_mobile" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Client Email</div>
                    <TextInput source="client_email" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Billing Name</div>
                    <TextInput source="billing_name" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>GstIn</div>
                    <TextInput source="gstin" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
            </div>
            <div className="formLabel-regular" style={{ marginTop: 8 }}>Parking Location</div>
            <div className="grid-250" style={{ marginTop: 8 }}>
                <RaAutocompleteInput multiple={true} source="parking_info_id" resourceParam="name" resourcePath="parkings" label="" getOptionValue={option => option["parking_info_id"]} getOptionLabel={option => `${option["general_name"]} : ${option["parking_info_id"]}`} style={{ width: "100%" }} filter={{ withOutClientInfo: true }} />
            </div>
            <div style={{ marginTop: 8 }}>
                <FormDataConsumer>
                    {({ formData, ...rest }) => {
                        let result;
                        let newResult;
                        if (formData && formData.client_parkings) {
                            result = formData.client_parkings.split("|")
                            newResult = result.map((val) => {
                                return { id: Number(val.split(':')[1].trim()), name: val }
                            })
                        }
                        return (
                            formData && formData.client_parkings && <AutocompleteArrayInput label="Remove Parkings" choices={newResult} source="remove_parking_info_ids" optionText={optionRenderer} options={{ suggestionsContainerProps: { placement: "bottom-start" } }} variant="outlined" style={{ width: "100%" }} />
                        )
                    }}
                </FormDataConsumer>
            </div>
            <RaImagesInput source="identity_proofs" style={{ margin: "30px 0 30px" }} />
        </SimpleForm>
    </Edit >)
};